import React, { ReactNode } from "react";
import { Box, useStyleConfig, BoxProps } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useShadcnInsetChrome } from "@/contexts/ShadcnInsetChromeContext";
import { isWorkspaceCanvasPathname } from "@/views/Dashboard/Workspace/workspaceRoutes";

interface PanelContainerProps extends BoxProps {
  variant?: string;
  children?: ReactNode;
}

function PanelContainer(props: PanelContainerProps) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("PanelContainer", { variant });
  const shadcnInset = useShadcnInsetChrome();
  const { pathname } = useLocation();
  const workspaceCanvas = isWorkspaceCanvasPathname(pathname);
  const merged = shadcnInset
    ? workspaceCanvas
      ? {
          ...styles,
          p: 0,
          flex: 1,
          minHeight: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }
      : { ...styles, p: 0, minHeight: "min-content" }
    : styles;
  return (
    <Box __css={merged} data-app-panel-container {...rest}>
      {children}
    </Box>
  );
}

export default PanelContainer;
